import Head from 'next/head'

import BrandsOvalBackground from '@/components/backgrounds/BrandsOval'
import DataIcon from '@/components/icons/Data'
import IoTIcon from '@/components/icons/IoT'
import VideoIcon from '@/components/icons/Video'
import CellularIcon from '@/components/icons/Wireless'
import Layout from '@/components/Layout'
import DishBusinessBrand from '@/public/img/commercial/brands/Dish-Business.png'
import DZSBrand from '@/public/img/commercial/brands/DZS.png'
import MikroTikBrand from '@/public/img/commercial/brands/MikroTik.png'
import PositronBrand from '@/public/img/commercial/brands/Positron.png'
import TelevesBrand from '@/public/img/commercial/brands/Televes.png'
import TrustHabBrand from '@/public/img/commercial/brands/TrustHab.png'
import UbiquitiBrand from '@/public/img/commercial/brands/Ubiquiti.png'
import ZyxelBrand from '@/public/img/commercial/brands/Zyxel.png'
import CablingImg from '@/public/img/commercial/Cabling.jpg'
import HeaderImg from '@/public/img/commercial/Commercial-Header.jpg'
import StagingAndConfigImg from '@/public/img/commercial/Staging-and-Configuration.jpg'
import TechSupportImg from '@/public/img/commercial/Tech-Support.jpg'
import DataTreeSvg from '@/public/img/Data-Tree.svg'
import SwooshSvg from '@/public/img/Swoosh.svg'

export default function Commercial(): JSX.Element {
	return (
		<div className="overflow-x-hidden">
			<Head>
				<title key="page-title">Commercial Solutions | Pace International</title>
			</Head>

			<div className="relative">
				<img className="absolute bottom-0 max-w-none -ml-4 -mr-24 -mb-16 sm:-mb-20 sm:-mr-32 md:-mr-36 md:-mb-24 lg:-mb-20 lg:-mr-44 xl:-mb-16 xl:-mr-52 2xl:-mr-64 2xl:-mb-24" src={SwooshSvg} alt="" />

				<section className="relative container mx-auto pt-6 px-4 sm:px-6 md:pt-9 xl:pt-12 xl:px-8">
					<h2 className="font-extrabold text-green-400 md:text-lg lg:text-xl xl:text-2xl">Commercial Market</h2>

					<div className="mt-4 md:flex md:mt-6 xl:mt-9">
						<div className="md:w-1/2">
							<h3 className="font-extrabold text-3xl md:text-4xl lg:text-5xl xl:text-6xl">Helping connect communities</h3>
							<p className="mt-3 lg:text-lg xl:text-xl">The demand for connectivity never stops. Pace proudly supports operators and integrators with products and services to help you deliver superior service to your customers.</p>
						</div>

						<div className="md:w-1/2 md:ml-12">
							<img className="mt-12 mx-auto rounded-lg shadow-lg md:rounded-xl md:mt-0 xl:rounded-2xl" src={HeaderImg} alt="Header" />
						</div>
					</div>
				</section>
			</div>

			<div className="container mx-auto px-3 mt-24 md:mt-28 md:px-6 xl:px-8">
				<section className="mt-24 md:mt-28">
					<div className="text-center">
						<h3 className="text-xl font-extrabold sm:text-2xl lg:text-3xl xl:text-4xl">What we offer the commercial business industry</h3>
						<p className="text-sm mt-3 sm:text-base md:mx-auto md:max-w-2xl lg:text-lg lg:max-w-4xl xl:max-w-5xl xl:text-xl">Whether it’s providing content to a single property or a nationwide chain with thousands of rooms, Pace has the strategy, products, shipping, and tech support to deliver the clear signals your client’s demand. We’re also DISH's national distributor in both hardware and content. So, wireless, satellite, or cable – we help you clear up the static.</p>
					</div>

					<div className="mt-10 md:flex md:items-start xl:mt-12">
						<div className="flex items-start md:w-1/2">
							<div className="w-1/2 flex flex-col items-center justify-center">
								<VideoIcon className="h-12 w-12 md:h-14 md:w-14 xl:w-16 xl:h-16 2xl:w-20 2xl:h-20"/>
								<div className="text-center mt-4 xl:mt-6">
									<h4 className="text-sm font-extrabold uppercase sm:text-base lg:text-lg">VIDEO</h4>
									<p className="text-xs mt-0.5 sm:text-sm lg:text-base xl:mt-1">Satellite TV for entertainment anywhere you travel.</p>
								</div>
							</div>

							<div className="w-1/2 flex flex-col items-center justify-center ml-9 sm:ml-12 md:ml-9 2xl:ml-16">
								<CellularIcon className="h-12 w-12 md:h-14 md:w-14 xl:w-16 xl:h-16 2xl:w-20 2xl:h-20"/>
								<div className="text-center mt-4 xl:mt-6">
									<h4 className="text-sm font-extrabold uppercase sm:text-base lg:text-lg">CELLULAR</h4>
									<p className="text-xs mt-0.5 sm:text-sm lg:text-base xl:mt-1">Signal boosters to help you stay connected anywhere.</p>
								</div>
							</div>
						</div>

						<div className="flex items-start mt-9 md:mt-0 md:w-1/2 md:ml-9 2xl:ml-16">
							<div className="w-1/2 flex flex-col items-center justify-center">
								<DataIcon className="h-12 w-12 md:h-14 md:w-14 xl:w-16 xl:h-16 2xl:w-20 2xl:h-20"/>
								<div className="text-center mt-4 xl:mt-6">
									<h4 className="text-sm font-extrabold uppercase sm:text-base lg:text-lg">DATA</h4>
									<p className="text-xs mt-0.5 sm:text-sm lg:text-base xl:mt-1">Point-to-point systems for strong data connections.</p>
								</div>
							</div>

							<div className="w-1/2 flex flex-col items-center justify-center ml-9 sm:ml-12 md:ml-9 2xl:ml-16">
								<IoTIcon className="h-12 w-12 md:h-14 md:w-14 xl:w-16 xl:h-16 2xl:w-20 2xl:h-20"/>
								<div className="text-center mt-4 xl:mt-6">
									<h4 className="text-sm font-extrabold uppercase sm:text-base lg:text-lg">IOT</h4>
									<p className="text-xs mt-0.5 sm:text-sm lg:text-base xl:mt-1">We aid in end-to-end IoT system design and product sourcing.</p>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>

			<section className="relative mt-16 md:mt-24 xl:mt-32">
				<div className="absolute inset-0 transform translate-x-1/2">
					<BrandsOvalBackground className="h-full transform -translate-x-1/2" />
				</div>

				<div className="relative container mx-auto grid grid-cols-2-auto py-20 px-10 gap-y-16 gap-x-12 md:px-44 md:py-32 lg:px-40 lg:py-48 lg:gap-x-9 lg:gap-y-24 lg:grid-cols-4-auto 2xl:px-52 2xl:py-52">
					<img className="mx-auto" src={DishBusinessBrand} alt="Dish-Business" />
					<img className="mx-auto" src={UbiquitiBrand} alt="Ubiquity" />
					<img className="mx-auto" src={TelevesBrand} alt="Televese" />
					<img className="mx-auto" src={DZSBrand} alt="DZS" />
					<img className="mx-auto" src={MikroTikBrand} alt="MikroTik" />
					<img className="mx-auto" src={PositronBrand} alt="Positron" />
					<img className="mx-auto" src={TrustHabBrand} alt="TustHab" />
					<img className="mx-auto" src={ZyxelBrand} alt="Zyxel" />
				</div>
			</section>

			{/* TODO: Flip images on mobile sizing */}
			<div className="container mx-auto mt-16 md:mt-24 px-3 md:px-6 xl:px-8 xl:mt-32">
				<section className="md:flex md:items-center">
					<div className="md:w-1/2">
						<h3 className="text-xl font-extrabold sm:text-2xl xl:text-3xl">Staging, configuration, & kitting</h3>

						<p className="text-sm mt-4 sm:text-base xl:text-xl xl:mt-6">Say goodbye to the complex sourcing process, system guesswork, and installation logistics. When you stage and deploy with Pace, you’re saving money, time, and headaches thanks to our custom labeling, repacking, and configuration services.</p>

						<ul className="list-disc ml-4 mt-4 text-sm space-y-2 sm:text-sm sm:space-y-3 lg:text-base xl:space-y-4 xl:text-xl xl:mt-6">
							<li>The right product mix for a job site to set, install and clean up, kitted and shipped to the site</li>
							<li>Products like installation hand tools, power tools, hardware, cleaning products, and more</li>
							<li>Private label products and unique ID numbers to help save money without sacrificing quality</li>
							<li>Easy replacements and repeat ordering with tracking for installation day efficiency</li>
							<li>Future firmware updates to ensure end-users remain up and running</li>
						</ul>
					</div>

					<div className="mt-12 max-w-md mx-auto md:max-w-full md:mt-0 md:w-1/2 md:ml-16">
						<img className="mx-auto rounded-lg shadow-lg md:rounded-xl xl:rounded-2xl" src={StagingAndConfigImg} alt="Staging and Configuration" />
					</div>
				</section>

				<section className="mt-16 sm:mt-20 md:mt-24 md:flex md:flex-row-reverse md:items-center xl:mt-32">
					<div className="md:w-1/2 md:ml-16">
						<h3 className="text-xl font-extrabold sm:text-2xl xl:text-3xl">Custom cabling, assembly, and light manufacturing</h3>

						<p className="text-sm mt-4 sm:text-base xl:text-xl xl:mt-6">Our fully functional, custom cabling will ensure all systems are communicating effectively. And if you need assembly and/or some light manufacturing to get the project as close to the finish line as possible, we take care of that, too.</p>

						<ul className="list-disc ml-4 mt-4 text-sm space-y-2 sm:text-sm sm:space-y-3 lg:text-base xl:space-y-4 xl:text-xl xl:mt-6">
							<li>Custom lengths</li>
							<li>Voice, audio, data, and video</li>
							<li>HDMI, fiber optic, coaxial, and ethernet</li>
						</ul>
					</div>

					<div className="mt-12 max-w-md mx-auto md:max-w-full md:mt-0 md:w-1/2">
						<img className="mx-auto rounded-lg shadow-lg md:rounded-xl xl:rounded-2xl"src={CablingImg} alt="Cabling" />
					</div>
				</section>

				<section className="mt-16 sm:mt-20 md:mt-24 md:flex md:items-center xl:mt-32">
					<div className="md:w-1/2">
						<h3 className="text-xl font-extrabold sm:text-2xl xl:text-3xl">Engineering & tech support</h3>

						<p className="text-sm mt-4 sm:text-base xl:text-xl xl:mt-6">Launching an entire properties’ telecommunication needs is no simple task. That’s why we support clients with years of expertise in system design and engineering, paired with deployment support to properly launch a property. Whether it’s backend sales support or a task that requires some technical savvy, we’ll make sure you close more deals and get projects done smoothly – from point A to Z, and beyond.</p>

						<p className="mt-4 sm:text-lg xl:text-2xl xl:mt-6">Our Technical Support team is on stand-by to keep you on-schedule. Give us a call at: <a className="text-green-400 font-extrabold underline" href="tel:18004447223">1-800-444-7223</a></p>
					</div>

					<div className="mt-12 max-w-md mx-auto md:max-w-full md:mt-0 md:w-1/2 md:ml-16">
						<img className="mx-auto rounded-lg shadow-lg md:rounded-xl xl:rounded-2xl" src={TechSupportImg} alt="Tech-Support" />
					</div>
				</section>

				<section className="mt-16 sm:mt-20 md:mt-24 xl:mt-32 xl:flex">
					<div className="hidden xl:w-max xl:block xl:h-max">
						<img src={DataTreeSvg} alt="" />
					</div>

					<div className="relative pb-16 xl:pb-0 xl:ml-24 xl:flex-1">
						<div className="absolute bottom-0 left-0 opacity-10 -ml-4 hidden sm:block md:-ml-6 xl:hidden">
							<img className="md:w-3/4 lg:w-5/6" src={DataTreeSvg} alt="" />
						</div>

						<div className="relative">
							<h3 className="text-xl font-extrabold sm:text-2xl xl:max-w-md xl:text-3xl">Pace connects all solutions for your business</h3>

							<div className="mt-9 md:flex">
								<div className="space-y-8 md:w-1/2">
									<div>
										<h4 className="font-extrabold text-sm text-green-400 uppercase sm:text-base lg:text-lg">dish satellite tv</h4>
										<p className="text-xs mt-0.5 sm:text-sm lg:text-base">Proudly offering DISH’s satellite TV programming for added value</p>
									</div>

									<div>
										<h4 className="font-extrabold text-sm text-green-400 uppercase sm:text-base lg:text-lg">Hardware solutions</h4>
										<p className="text-xs mt-0.5 sm:text-sm lg:text-base">Routers, splitters, extenders, and connectors that support the newest audio/video technology.</p>
									</div>

									<div>
										<h4 className="font-extrabold text-sm text-green-400 uppercase sm:text-base lg:text-lg">Installation Tools &amp; supplies</h4>
										<p className="text-xs mt-0.5 sm:text-sm lg:text-base">In addition to DISH equipment, we supply all necessary audio and video installation equipment.</p>
									</div>

									<div>
										<h4 className="font-extrabold text-sm text-green-400 uppercase sm:text-base lg:text-lg">Custom cabling</h4>
										<p className="text-xs mt-0.5 sm:text-sm lg:text-base">With assembly and light manufacturing available, we supply fully functional cabling.</p>
									</div>
								</div>

								<div className="space-y-8 mt-8 md:mt-0 md:w-1/2 md:ml-20">
									<div>
										<h4 className="font-extrabold text-sm text-green-400 uppercase sm:text-base lg:text-lg">Professional A/V Distribution</h4>
										<p className="text-xs mt-0.5 sm:text-sm lg:text-base">Cat 5e/6 or Coax, easily convert HD video signals to HDMI using Pace HDMI Matrix solutions.</p>
									</div>

									<div>
										<h4 className="font-extrabold text-sm text-green-400 uppercase sm:text-base lg:text-lg">Routers and lte products</h4>
										<p className="text-xs mt-0.5 sm:text-sm lg:text-base">Hundreds of vendors help us supply all vital components for your connectivity needs.</p>
									</div>

									<div>
										<h4 className="font-extrabold text-sm text-green-400 uppercase sm:text-base lg:text-lg">Cellular boosters</h4>
										<p className="text-xs mt-0.5 sm:text-sm lg:text-base">Reliable voice and 4G LTE data signal for all major North American cell carriers.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	)
}

Commercial.Layout = Layout
